import React from 'react'

const DownArrowIcon = props => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M17.9197 8.18005H11.6897H6.07975C5.11975 8.18005 4.63975 9.34005 5.31975 10.0201L10.4997 15.2001C11.3297 16.0301 12.6797 16.0301 13.5097 15.2001L15.4797 13.2301L18.6897 10.0201C19.3597 9.34005 18.8797 8.18005 17.9197 8.18005Z'
        fill='#1F1F1F'
      />
    </svg>
  )
}

export default DownArrowIcon
